import { NewCollectionLayout } from '../NewCollectionLayout';

type Props = {
  slug: string;
  collection: string;
};
export const CollectionLayout = (props: Props) => {
  const { slug, collection } = props;
  return (
    <NewCollectionLayout collection={collection} userSlug={slug} fromMyClub />
  );
};
